import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import { SimpleImg } from 'react-simple-img'

import Image from 'components/Image'

import style from './StaffItem.style'

const StaffItemStyled = styled.div(props => ({ ...style(props) }))

const StaffItem = ({ t, image, name, position, speaking, description, columns }) => {
    const getImage = () => {
        if (image.length === 0) {
            return '/images/fallback/staff.svg'
        }
        return image
    }

    return (
        <StaffItemStyled columns={columns === 2 && columns}>
            <div className="staffItem-image">
                <SimpleImg alt={name} src={getImage()} className="staffItem-imageImage" />
            </div>
            {(name || position || speaking || description) && (
                <div className="staffItem-content">
                    {/* eslint-disable react/no-danger */}
                    {name && name.length > 0 && (
                        <div className="staffItem-contentName" dangerouslySetInnerHTML={{ __html: name }} />
                    )}
                    {position && position.length > 0 && (
                        <div className="staffItem-contentPosition" dangerouslySetInnerHTML={{ __html: position }} />
                    )}
                    {speaking && speaking.length > 0 && (
                        <div className="staffItem-contentSpeaking">
                            {t('speaking')} <span dangerouslySetInnerHTML={{ __html: speaking }} />
                        </div>
                    )}
                    {description && description.length > 0 && (
                        <div
                            className="staffItem-contentDescription"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}
                </div>
            )}
        </StaffItemStyled>
    )
}

StaffItem.propTypes = {
    t: PropTypes.func.isRequired,
    image: PropTypes.string,
    name: PropTypes.string,
    position: PropTypes.string,
    speaking: PropTypes.string,
    description: PropTypes.string,
    columns: PropTypes.oneOf([2, 4])
}

StaffItem.defaultProps = {
    image: '/images/fallback/staff.svg',
    name: undefined,
    position: undefined,
    speaking: undefined,
    description: undefined,
    columns: 4
}

export default withTranslation('common')(withTheme(StaffItem))
